export default "__VITE_ASSET__DMcN_S_D__"